import React from 'react';

type P = { size?: number };
const base = (size: number) => ({
  width: size, height: size, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor',
  strokeLinecap: 'round' as const, strokeLinejoin: 'round' as const, 'aria-hidden': true,
});

export const MicSvg: React.FC<P> = ({ size = 22 }) => (
  <svg {...base(size)} strokeWidth={2.2}><rect x="9" y="3" width="6" height="11" rx="3" /><path d="M5 11a7 7 0 0 0 14 0M12 18v3" /></svg>
);
export const ChatSvg: React.FC<P> = ({ size = 22 }) => (
  <svg {...base(size)} strokeWidth={1.8}><path d="M4 5h16v11H9l-5 4z" /></svg>
);
export const BackSvg: React.FC<P> = ({ size = 20 }) => (
  <svg {...base(size)} strokeWidth={2}><path d="M15 5l-7 7 7 7" /></svg>
);
export const InfoSvg: React.FC<P> = ({ size = 20 }) => (
  <svg {...base(size)} strokeWidth={2}><circle cx="12" cy="12" r="9" /><path d="M12 11v6M12 7.5v.01" /></svg>
);
